[
  {
    "costHan": 0,
    "id": "meet-your-tour-guide",
    "requirement": {
      "kind": "none"
    },
    "scope": {
      "kind": "global"
    },
    "steps": [
      {
        "kind": "han",
        "markdown": "Hi! I'm Han, your tour guide!\n\nTap on my avatar to get started!",
        "text": "Hi! I'm Han, your tour guide! Tap on my avatar to get started!"
      },
      {
        "kind": "han",
        "text": "I'll be helping you practice conversations in Chinese through missions as you explore China."
      },
      {
        "kind": "han",
        "text": "Just one rule: to complete a mission, you must speak fully in Mandarin."
      },
      {
        "kind": "han",
        "text": "Since you're just starting out, I'll continue to use English until your vocabulary expands."
      },
      {
        "kind": "han",
        "markdown": "Are you ready?\\\nTap the mic on your right to unmute yourself, then count down from 3 in Chinese and we'll get started!",
        "text": "Are you ready? Tap the mic on your right to unmute yourself, then count down from 3 in Chinese and we'll get started!"
      },
      {
        "answer": {
          "english": "three, two, one",
          "pinyin": "san1 er4 yi1",
          "simplified": "三二一",
          "traditional": "三二一"
        },
        "hint": {
          "kind": "han",
          "mandarin": {
            "english": "In Chinese, counting up to three is:",
            "pinyin": "yi1 er4 san1",
            "simplified": "一二三",
            "traditional": "一二三"
          },
          "afterMandarin": {
            "markdown": "Now, can you count _down_ from three to one?",
            "text": "Now, can you count down from three to one?"
          },
          "text": "In Chinese, counting up to three is:"
        },
        "intents": [
          {
            "examples": [
              [
                {
                  "pinyin": "san1 er4 yi1",
                  "word": "三二一"
                }
              ]
            ],
            "intentKey": "count-down"
          }
        ],
        "kind": "reply"
      },
      {
        "kind": "han",
        "text": "Let's get going!"
      }
    ],
    "summary": "Han, your tour guide, shows you how missions work.",
    "title": "Meet your tour guide",
    "xp": 20
  },
  {
    "costHan": 0,
    "id": "ask-for-a-calendar",
    "requirement": {
      "kind": "pronunciation-level",
      "pronunciationIndex": 1
    },
    "scope": {
      "kind": "global"
    },
    "steps": [
      {
        "kind": "han",
        "text": "They gave me a free gift at the supermarket but I already have tons of these."
      },
      {
        "kind": "han",
        "text": "How about this: If you know the word for it in Chinese, I’ll give one to you!"
      },
      {
        "kind": "scene",
        "scene": "calendar"
      },
      {
        "answer": {
          "english": "calendar",
          "pinyin": "ri4li4",
          "simplified": "日历",
          "traditional": "日曆"
        },
        "intents": [
          {
            "examples": [
              [
                {
                  "pinyin": "ri4li4",
                  "word": "日历"
                }
              ],
              [
                {
                  "pinyin": "ri4li4",
                  "word": "日曆"
                }
              ],
              [
                {
                  "pinyin": "shi4 ri4li4",
                  "word": "是日历"
                }
              ],
              [
                {
                  "pinyin": "zhe4 shi4 ri4li4",
                  "word": "这是日历"
                }
              ]
            ],
            "intentKey": "calendar",
            "slotGroups": [
              {
                "members": [
                  [
                    {
                      "pinyin": "ri4li4",
                      "word": "日历"
                    }
                  ],
                  [
                    {
                      "pinyin": "ri4li4",
                      "word": "日曆"
                    }
                  ]
                ]
              }
            ]
          }
        ],
        "kind": "reply"
      },
      {
        "kind": "han",
        "mandarin": {
          "english": "That's right! This calendar is yours.",
          "pinyin": "dui4! zhe4ge0 ri4li4 gei3 ni3.",
          "simplified": "对！这个日历给你。",
          "traditional": "對！這個日曆給你。"
        },
        "text": "That's right! This calendar is yours."
      }
    ],
    "summary": "Name Han's free supermarket gift in Chinese and he'll give one to you.",
    "title": "Calendar",
    "xp": 20
  },
  {
    "costHan": 0,
    "id": "pick-your-calendar",
    "requirement": {
      "kind": "pronunciation-level",
      "pronunciationIndex": 2
    },
    "scope": {
      "kind": "global"
    },
    "steps": [
      {
        "kind": "han",
        "text": "How many calendars do you see?"
      },
      {
        "kind": "scene",
        "scene": "calendars"
      },
      {
        "answer": {
          "english": "four",
          "pinyin": "si4ge4",
          "simplified": "四个",
          "traditional": "四個"
        },
        "intents": [
          {
            "examples": [
              [
                {
                  "pinyin": "si4ge4",
                  "word": "四个"
                }
              ],
              [
                {
                  "pinyin": "you3 si4ge4",
                  "word": "有四个"
                }
              ],
              [
                {
                  "pinyin": "si4ge4 ri4li4",
                  "word": "四个日历"
                }
              ],
              [
                {
                  "pinyin": "wo3 kan4jian4 si4ge4 ri4li4",
                  "word": "我看见四个日历"
                }
              ]
            ],
            "intentKey": "four-calendars",
            "slotGroups": [
              {
                "members": [
                  [
                    {
                      "pinyin": "si4ge4",
                      "word": "四个"
                    }
                  ]
                ]
              }
            ]
          }
        ],
        "kind": "reply"
      },
      {
        "kind": "han",
        "text": "Hm, which one do you want?"
      },
      {
        "kind": "narration",
        "text": "Say “this calendar” in Chinese when Han shows a style you like."
      },
      {
        "kind": "scene",
        "scene": "calendar-styles"
      },
      {
        "answer": {
          "english": "this calendar",
          "pinyin": "zhe4ge0 ri4li4",
          "simplified": "这个日历",
          "traditional": "這個日曆"
        },
        "intents": [
          {
            "examples": [
              [
                {
                  "pinyin": "zhe4ge0 ri4li4",
                  "word": "这个日历"
                }
              ],
              [
                {
                  "pinyin": "zhe4ge0 ri4li4",
                  "word": "這個日曆"
                }
              ],
              [
                {
                  "pinyin": "wo3 yao4 zhe4ge0 ri4li4",
                  "word": "我要这个日历"
                }
              ],
              [
                {
                  "pinyin": "wo3 xi3huan0 zhe4ge0 ri4li4",
                  "word": "我喜欢这个日历"
                }
              ]
            ],
            "intentKey": "this-calendar",
            "slotGroups": [
              {
                "members": [
                  [
                    {
                      "pinyin": "zhe4ge0 ri4li4",
                      "word": "这个日历"
                    }
                  ],
                  [
                    {
                      "pinyin": "zhe4ge0 ri4li4",
                      "word": "這個日曆"
                    }
                  ],
                  [
                    {
                      "pinyin": "zhe4 yi2ge4 ri4li4",
                      "word": "这一个日历"
                    }
                  ]
                ]
              }
            ]
          }
        ],
        "kind": "reply"
      },
      {
        "kind": "han",
        "mandarin": {
          "english": "Great choice. It's yours!",
          "pinyin": "hao3! zhe4ge0 ri4li4 gei3 ni3.",
          "simplified": "好！这个日历给你。",
          "traditional": "好！這個日曆給你。"
        },
        "text": "Great choice. It's yours!"
      }
    ],
    "summary": "Count Han's calendars, then choose a style you like.",
    "title": "This One",
    "xp": 20
  },
  {
    "costHan": 0,
    "id": "dirty-calendar",
    "requirement": {
      "kind": "pronunciation-level",
      "pronunciationIndex": 3
    },
    "scope": {
      "kind": "global"
    },
    "steps": [
      {
        "kind": "narration",
        "text": "Describe to Han what happened to your calendar:"
      },
      {
        "kind": "scene",
        "scene": "dirty-calendar"
      },
      {
        "answer": {
          "english": "My calendar got dirty.",
          "pinyin": "wo3 de0 ri4li4 zang1 le0",
          "simplified": "我的日历脏了",
          "traditional": "我的日曆髒了"
        },
        "intents": [
          {
            "examples": [
              [
                {
                  "pinyin": "wo3 de0 ri4li4 zang1 le0",
                  "word": "我的日历脏了"
                }
              ],
              [
                {
                  "pinyin": "wo3 de0 ri4li4 zang1 le0",
                  "word": "我的日曆髒了"
                }
              ],
              [
                {
                  "pinyin": "ri4li4 zang1 le0",
                  "word": "日历脏了"
                }
              ],
              [
                {
                  "pinyin": "zhe4ge0 ri4li4 zang1 le0",
                  "word": "这个日历脏了"
                }
              ],
              [
                {
                  "pinyin": "wo3 de0 ri4li4 hen3 zang1",
                  "word": "我的日历很脏"
                }
              ]
            ],
            "intentKey": "calendar-got-dirty",
            "negativeExamples": [
              [
                {
                  "pinyin": "wo3 de0 ri4li4 bu4 zang1",
                  "word": "我的日历不脏"
                }
              ],
              [
                {
                  "pinyin": "ri4li4 mei2 zang1",
                  "word": "日历没脏"
                }
              ]
            ],
            "slotGroups": [
              {
                "members": [
                  [
                    {
                      "pinyin": "ri4li4",
                      "word": "日历"
                    }
                  ],
                  [
                    {
                      "pinyin": "ri4li4",
                      "word": "日曆"
                    }
                  ]
                ]
              },
              {
                "members": [
                  [
                    {
                      "pinyin": "zang1",
                      "word": "脏"
                    }
                  ],
                  [
                    {
                      "pinyin": "zang1",
                      "word": "髒"
                    }
                  ]
                ]
              }
            ]
          }
        ],
        "kind": "reply"
      },
      {
        "kind": "han",
        "mandarin": {
          "english": "Oh no! Your calendar got dirty.",
          "pinyin": "ni3 de0 ri4li4 zang1 le0!",
          "simplified": "你的日历脏了！",
          "traditional": "你的日曆髒了！"
        },
        "text": "Oh no! Your calendar got dirty."
      }
    ],
    "summary": "Describe to Han what happened to your calendar.",
    "title": "Change of State",
    "xp": 20
  }
]
